export default "__VITE_ASSET__CdY$xOsv__"